export default __webpack_public_path__ + "static/media/d933c1d9-2415-41f5-823b-b86ca8a68ee1.a0cb5ddd.jpg";